import { css } from '@emotion/react';

const makePhoneNumberInputStyling = (theme) => {
  return {
    box: css({
      marginBottom: theme.mvf.spacing.medium,
      marginTop: theme.mvf.spacing.medium,
    }),
    textFieldBox: css({
      marginTop: theme.mvf.spacing.medium,
      '& .iti__country-list': {
        maxHeight: '75px',
      },
    }),
    hiddenInputForPersistentKeyboard: css({
      position: 'absolute',
      left: '-99999px',
    }),
  };
};

export default makePhoneNumberInputStyling;
